<template>
  <dara-single-content-layout container-size="lg">
    <template v-if="department" #content>
      <div class="row">
        <div class="col">
          <dara-header>
            {{ department.name }}
          </dara-header>
          <dara-p v-if="department.description" class="dara-u-text--medium">
            {{ department.description }}
          </dara-p>
          <small class="text-muted dara-u-text--small d-block mt-2">
            {{ $t('reading-time') }}: {{ total_time }} min
          </small>
          <small class="d-flex align-items--center text-muted dara-u-text--small d-block">
            {{ $t('number-of-articles') }}: {{ number_of_articles }}
          </small>
          <small class="text-muted dara-u-text--small d-block mb-2">
            {{ $t('updated') }} {{ department.updated_at }}
          </small>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <dara-header size="md" class="mb-3">
            {{ $t('articles') }}
            <el-tooltip effect="dark" :content="$t('some-articles-may-not-appear-due-to-permission')" placement="right-end">
              <dara-icon size="md" icon="info-circle-fill" class="ms-1" />
            </el-tooltip>
          </dara-header>
        </div>
      </div>
      <div v-if="articles && articles.length > 0">
        <div v-for="article in articles" :key="article.id" class="mb--xl">
          <dara-article-card :article="article" />
        </div>
        <dara-pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :page-size="pagination.limit"
          @current-change="fetchArticles" />
      </div>
      <div v-else>
        <dara-p class="opacity--50 my--md">( {{ $t('no-articles') }} )</dara-p>
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { getDepartmentById } from '@/modules/department/department.service';
import { fetchDepartmentArticles } from '@/modules/article/article.service';

import DaraArticleCard from '@/modules/article/components/ArticleCard.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DepartmentPage',
  components: {
    DaraArticleCard,
    DaraSingleContentLayout,
  },
  data() {
    return {
      department: null,
      articles: [],
      number_of_articles: null,
      total_time: null,
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  computed: {
    id() {
      return this.$route.params?.id;
    },
  },
  mounted() {
    this.fetchDepartment();
  },
  methods: {
    fetchDepartment() {
      getDepartmentById(this.id)
        .then(data => {
          this.department = data;
          this.chooseAllArticles();
        })
        .catch(() => { this.department = []; });
    },
    fetchArticles() {
      this.chooseAllArticles();
    },
    chooseAllArticles() {
      fetchDepartmentArticles(this.department.id, this.pagination)
        .then(data => {
          this.articles = data.data;
          this.total_time = data.total_time;
          this.number_of_articles = this.articles.length;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => { this.department = []; });
    },
  },
};
</script>
